/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useMemo, useState } from 'react'
// utils
import { isHexColorMuted, isLight } from 'utils/theme'
// material
import { ColorPicker, Switch, Tip } from '@insticator/insticator-ui/dist/material'
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './colors_styles'

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : COLORS ~~~~~~~~~~ ========== */
const Colors = injectSheet(styles)((props) => {

  const { siteTheme, setSiteThemeConfig, setSiteThemeConfigs, isConfigOpen } = props

  const [colorSchema, ] = useState({
    customBackgroundColor: siteTheme.customBackgroundColor,
    customPrimaryColor: siteTheme.customPrimaryColor
  })

  const [tempColors, setTempColors] = useState({
    customPrimaryColor: siteTheme.customPrimaryColor
  })

  const [colorSchemaValid, setColorSchemaValid] = useState({
      customBackgroundColor: true, customPrimaryColor: true
  })

  useEffect(() => {
    if(!isConfigOpen) {
      setColorSchemaValid({customBackgroundColor: true, customPrimaryColor: true})
      setTempColors({ customPrimaryColor: siteTheme.customPrimaryColor})
    } 
  },[isConfigOpen])


  const handlePrimaryColorChange = color => {
    setTempColors({ customPrimaryColor: color })
    setSiteThemeConfig('customPrimaryColor', color)
  }

  const handleBackgroundChange = (color) => {
    const modeStyle = isLight(color) ? 'LIGHT' : 'DARK'
    setSiteThemeConfigs({
      customBackgroundColor: color
    })
  }

  const validateColor = (isValid, name) => {
    setColorSchemaValid({
      ...colorSchemaValid,
      [name]: isValid
    })
  }

  const handleReset = (color) => setSiteThemeConfig(color, colorSchema[color])

  const handleMonochromeChange = () => {
    setSiteThemeConfigs({
      enableMonochrome: !siteTheme.enableMonochrome,
      customPrimaryColor: 
        siteTheme.enableMonochrome ? (tempColors.customPrimaryColor === '#000000' ? '#061240' : tempColors.customPrimaryColor) 
        : tempColors.customPrimaryColor
    })
  }

  const hasLowSaturation = useMemo(() => {
    if(siteTheme.enableMonochrome) return false
    return isHexColorMuted(siteTheme.customPrimaryColor)
  }, [siteTheme.customPrimaryColor, siteTheme.enableMonochrome])


  return (
    <SectionGroupV2 
      klass={`colors ${props.classes.colors}`}
      title={'Colors'} 
      description={'Match your sites color scheme by selecting some basic hues.'}
      direction={'column'}
    >
      <Space klass={'backgroundcolor'} alignItems={'center'}>
        <ColorPicker 
          valid={colorSchemaValid.customBackgroundColor}
          color={siteTheme.customBackgroundColor || '#FFFFFF'}
          savedColor={siteTheme.customBackgroundColor || '#FFFFFF'}
          label={<span>Background <Tip space={'none'} icon={'question-circle'} content={'This color should match the background color where your article sentiment unit will display.'} label={''} /></span>}
          handleColorChange={(color, e) => handleBackgroundChange(color)}
          processColorUpdate={(color, e) => handleBackgroundChange(color)}
          validateColor={(isValid, e) => validateColor(isValid, 'customBackgroundColor')}
          handleReset={() => handleReset('customBackgroundColor')} 
        />
      </Space>

    <Space klass={`primarycolor disabled-${!!siteTheme.enableMonochrome}`} alignItems={'center'}>
      <ColorPicker 
        valid={colorSchemaValid.customPrimaryColor} 
        label={'Primary'} 
        color={siteTheme.customPrimaryColor || '#061240'} 
        savedColor={siteTheme.customPrimaryColor || '061240'} 
        processColorUpdate={(color, e) => {
          handlePrimaryColorChange(color)
        }}
        handleColorChange={(color, e) => handlePrimaryColorChange(color)}
        validateColor={(isValid, e) => validateColor(isValid, 'customPrimaryColor')} 
        handleReset={() => handleReset('customPrimaryColor')} 
      />
        <Space klass={'usemonochrome'} gap={8} alignItems={'center'}>
          <Switch 
            on={!!siteTheme.enableMonochrome} 
            handleClick={() => handleMonochromeChange(!siteTheme.enableMonochrome)} 
          />
          <span>Monochrome</span>
          <Tip 
            content={`When enabled, the article sentiment unit will display in grayscale.`}
            label={''}
          />
        </Space>
    </Space>
    <div className='errormessage'>{hasLowSaturation && `Color has low saturation. Please select another primary color.`}</div>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Colors